module.exports = __webpack_public_path__ + "static/img/login-bg-1.d030246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg-1.png
// module id = qyBg
// module chunks = 1